export interface View {
  id: string;
  name: string;
  slug: string;
  isSystem: boolean;
  /**
   * Auto-generated per-counterparty view: one per counterparty on the first page of the
   * server's tab list (by name). Creation + lifecycle are owned by
   * `syncCounterpartyTabs` in the views store; these views are read-only from the UI. A
   * counterparty tab that is NOT auto-generated was opened from the "+N more" menu or a link
   * and closes with its X.
   */
  isAutoGenerated?: boolean;
  /** Counterparty filter for this view. Empty array = All Trades (no filter). */
  counterparties: string[];
  /** The counterparty's id; absent on All Trades and on a tab persisted before ids. */
  counterpartyId?: number;
  /** A deactivated counterparty: the tab reads "(inactive)". */
  isInactive?: boolean;
}

/** A counterparty a tab is opened or kept for. */
export interface TabCounterparty {
  id: number;
  name: string;
  isActive: boolean;
}

export const ALL_TRADES_VIEW: View = Object.freeze({
  id: 'all-trades',
  name: 'All Trades',
  slug: 'all-trades',
  isSystem: true,
  counterparties: Object.freeze([] as string[]) as string[],
});
